/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the IssueCertificateCredentialRequest interface.
 */
export function instanceOfIssueCertificateCredentialRequest(value) {
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('publicKeyPem' in value) || value['publicKeyPem'] === undefined)
        return false;
    return true;
}
export function IssueCertificateCredentialRequestFromJSON(json) {
    return IssueCertificateCredentialRequestFromJSONTyped(json, false);
}
export function IssueCertificateCredentialRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'label': json['label'],
        'publicKeyPem': json['public_key_pem'],
    };
}
export function IssueCertificateCredentialRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'label': value['label'],
        'public_key_pem': value['publicKeyPem'],
    };
}
